<template>
  <div>
    <v-autocomplete v-model="accountRef" outlined dense :label="label"
                    :items="accounts" item-text="name" item-value="ref"
                    :hint="hint" persistent-hint @change="$emit('input',accountRef);$emit('change',accountRef)"
                    :hide-details="hint===undefined"
                    :disabled="disabled" :rules="[required?fieldRules.required:true]">
      <template v-slot:prepend-item v-if="addTypes">
        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="accountCreate=true">
          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new account
        </div>
      </template>
      <template v-slot:item="{item}">
        <v-list-item-content :class="item.parentRef?'ml-6':''">{{item.name}}</v-list-item-content>
        <v-list-item-action class="text-caption">{{item.typeName}}</v-list-item-action>
      </template>
      <template v-slot:prepend>
        <slot name="prepend"/>
      </template>
    </v-autocomplete>

    <v-dialog v-model="accountCreate" persistent max-width="350">
      <v-card>
        <v-card-title>Create account</v-card-title>
        <v-divider/>
          <v-form v-model="valid" immediate ref="form">
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field label="Name" v-model="account.name" :rules="[fieldRules.required,fieldRules.maxLength(100)]" outlined dense :counter="100"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete label="Type" v-model="account.type" :items="types" outlined dense/>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn plain color="primary" @click="accountCreate=false">Cancel</v-btn>
          <v-btn color="primary" @click="createAccount()" :loading="busy">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AccountPicker',
	props: {
    value: {type:String,required:true,default:''},
    label: {type:String, required:true},
    accounts: {type:Array, required:true},
    hint: {type:String, required:false},
    disabled: {type:Boolean, required:false, default:false},
    addTypes: {type:Array, required:false},
    required: {type:Boolean, required:false, default:false}
  },
  data() {
    return {
      valid: true,
      accountRef: false,
      accountCreate: false,
      accountsList: [],
      account: {name:'',type:''},
      accountTypes: [{value:'Bank',text:'Bank'},
                    {value:'OtherCurrentAsset',text:'Inventory'},
                    {value:'FixedAsset',text:'Fixed Asset'},
                    {value:'OtherAsset',text:'Other Asset'},
                    {value:'AccountsReceivable',text:'Accounts Receivable'},
                    {value:'Equity',text:'Equity'},
                    {value:'Expense',text:'Expense'},
                    {value:'OtherExpense',text:'Other Expense'},
                    {value:'CostOfGoodsSold',text:'Cost of Goods Sold'},
                    {value:'AccountsPayable',text:'Accounts Payable'},
                    {value:'CreditCard',text:'Credit Card'},
                    {value:'LongTermLiability',text:'Long Term Liability'},
                    {value:'OtherCurrentLiability',text:'Other Current Liability'},
                    {value:'Income',text:'Income'},
                    {value:'OtherIncome',text:'Other Income'}],
      busy: false
    }
  },
  computed: {
    types() {
      return this.addTypes ? this.accountTypes.filter(type => this.addTypes.some(t => t === type.value)) : [];
    }
  },
  created() {
    this.accountsList = this.accounts;
    this.accountRef = this.value;
    this.account.type = this.addTypes ? this.addTypes[0] : '';
  },
  watch: {
    value() {
      this.accountRef = this.value;
    },
    accounts() {
      this.accountsList = this.accounts;
    }
  },
  methods: {
    async createAccount() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.busy = true;
      const results = await this.$apiCall(`mutation AccountPicker($input: AccountCreateInput!) {
                                            accountCreate(input:$input) {ref,name,type,typeName}
                                          }`,
                                          {input:this.account});
      this.busy = false;
      if (!results.error) {
        this.accountsList.push(results.data.accountCreate);
        this.accountCreate = false;
        this.accountRef = results.data.accountCreate.ref;
        this.$emit('input', this.accountRef);
      }
    }
  }
}
</script>